import React, { DependencyList } from 'react';
import { ProfileType, ProfileInfo } from '@/types';
import { ProjectIcon, ProfileIcon } from '@/components/Icons';

interface HeaderProfileThumbnailProps {
    profile: ProfileInfo;
    sizeInPx: number;
    className?: string;
    cacheDependencies?: DependencyList;
}

const HeaderProfileThumbnail: React.FC<HeaderProfileThumbnailProps> = ({
    profile,
    sizeInPx,
    className,
    cacheDependencies,
}) => {
    if (profile.profileType === ProfileType.Buyer) {
        return (
            <ProjectIcon
                cacheDependencies={cacheDependencies}
                projectId={profile.projectId}
                sizeInPx={sizeInPx}
                shape="square"
                className={className}
            />
        );
    }

    return (
        <ProfileIcon
            cacheDependencies={cacheDependencies}
            profileId={profile.profileId}
            sizeInPx={sizeInPx}
            shape="square"
            className={className}
        />
    );
};

export default HeaderProfileThumbnail;